module.exports = __webpack_public_path__ + "static/img/qItem3-img2.0cd503c.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/qItem3-img2.png
// module id = a5LC
// module chunks = 1